export default {
    url(endpoint, params, includeCsrfParam) {

        if(!params) {
            params = {};
        }

        Object.keys(params).forEach((key) => {
            endpoint = ("" + endpoint).replace(new RegExp('\@' + key + '\@', 'g'), params[key]);
        });

        if(includeCsrfParam) {
            let querySymbol = (endpoint.indexOf('?') !== -1) ? '&' : '?';
            let csrfToken = this.csrf();

            return `${endpoint}${querySymbol}_token=${csrfToken}`;
        }

        return endpoint;

    },

    upload(endpoint, params, file, headers, fileFieldName) {

        if(!headers) {
            headers = {};
        }

        if(!fileFieldName) {
            fileFieldName = 'file';
        }

        let formData = new FormData();

        if(params) {
            for(let i in params) {
                if(!params.hasOwnProperty(i)) continue;
                formData.append(i, params[i]);
            }
        }

        formData.append(fileFieldName, file);

        return axios.post(
            endpoint,
            formData,
            {headers: {'Content-Type': 'multipart/form-data', ...headers}}
        ).then((res) => {
            return res.data;
        })

    },

    csrf() {

        if(window.CSRF_TOKEN) {
            return window.CSRF_TOKEN;
        }

        let element = document.head.querySelector('meta[name="csrf-token"]');

        if(!element) {
            console.error("Could not find CSRF Token element in page!");
            return '';
        }

        return window.CSRF_TOKEN = element.content;

    }
}
